import { closeBrowser, getBrowser } from "@/common/utils";
import React from "react";


export default class OmniHeroesBackGame extends React.Component{
    render() {
        const uid = true || sessionStorage.getItem('uid')
        const language = sessionStorage.getItem('language')
        return (
            uid ? <div className={ `back-game ${language}` } onClick={this.toBack}></div> : null
        )
    }

    toBack() {
        closeBrowser()
    }
}